import * as React from "react";
import "./styles.scss";

interface HierarchySelectStatusCounterProps {
	text: string;
	title: string;
	count: number;
	onDeselectAll: () => any;
}

export const HierarchySelectStatusCounter: React.FC<
	HierarchySelectStatusCounterProps
> = ({ text, onDeselectAll, title, count }) => {
	let resetter = null;
	if (count > 0) {
		resetter = (
			<div
				className="hierarchy-filter-counter-cancel-button"
				onClick={onDeselectAll}
			>
				<span
					style={{ fontSize: "14px" }}
					className="material-icons-outlined clickable"
				>
					clear
				</span>
			</div>
		);
	} else {
		return null;
	}

	return (
		<div className="hierarchy-filter-counter-container">
			<p title={title}>
				{count} {text}
			</p>
			{resetter}
		</div>
	);
};
